import React, {useCallback, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {useDispatch, useSelector} from "react-redux";
import { ContainerHeader, SortableTableMat } from "../../module";
import separate from "../../functions/separate/separate";
import {number} from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import {Link, useHistory} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import {TableSortLabel} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import debounce from "../../utils/debuce";
import DeleteIcon from "@mui/icons-material/Delete";
import {deleteUser} from "../../../stores/user/userThunk";
import ModalAlerterCallback from "../../utils/ModalAlerterCallback";
import {deleteNotice} from "../../../stores/notice/thunk";
import EditIcon from "@mui/icons-material/Edit";
import {deleteDiscountCode} from "../../../stores/discountCode/thunk";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    actions: {
        display: 'flex !important',
        flexDirection: 'row',
        gap: '0 10px'
    },
    editIcon: {
        color: '#FF8C00',
    },
    deleteIcon: {
        color: 'red',
    },
    viewEx: {
        color: '#0054a7',
    },
    item: {
        padding: '16px 8px',
    },
}));


const headCells = [
    {
        id: 'code',
        numeric: false,
        disablePadding: false,
        label: 'کد تخفیف',
    },
    {
        id: 'type',
        numeric: false,
        disablePadding: false,
        label: 'نوع تخفیف',
    },
    {
        id: 'count',
        numeric: false,
        disablePadding: false,
        label: 'تعداد',
    },
    {
        id: 'used',
        numeric: false,
        disablePadding: false,
        label: 'استفاده شده',
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'وضعیت',
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: '',
        sort: true,
    },
];

export default function DiscountCodes() {

    const dispatch = useDispatch();
    const history = useHistory();

    const [params, setParams] = useState({
        user_fullname: '',
    });


    function removeNotice(discount_id, refreshTable) {
        const callback = () =>
            dispatch(deleteDiscountCode({discount_id}, refreshTable));
        ModalAlerterCallback(callback);
    }

    const ExerciseHeadMedel = (props) => {
        const classes = useStyles();
        const {headCell, order, orderBy} = props;

        return (
            <TableCell
                key={headCell.id}
                align={headCell.numeric ? 'right' : 'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
            >
                <TableSortLabel
                    active={orderBy === headCell.id}
                    direction={orderBy === headCell.id ? order : 'asc'}
                    // onClick={createSortHandler(headCell.id)}
                >
                    {headCell.label}
                    {orderBy === headCell.id ? (
                        <span className={classes.visuallyHidden}>
            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
          </span>
                    ) : null}
                </TableSortLabel>
            </TableCell>
        );
    };

    const ExerciseRowTableModel = (props) => {
        const dispatch = useDispatch();
        const history = useHistory();
        const classes = useStyles();
        const {row, onRemove, refreshTable} = props;

        function handleRemove() {
            onRemove(row.id, refreshTable);
        }



        return (
            <TableRow hover tabIndex={-1} key={row.id}>
                <TableCell align="left">{row.code}</TableCell>
                <TableCell align="left">{row?.amount?.price ? separate(row?.amount?.price) : row?.amount?.percent+"%"}</TableCell>
                <TableCell align="left">{row.condition?.Count}</TableCell>
                <TableCell align="left">{row?.used}</TableCell>
                <TableCell align="left">{row?.status === 1 ? "فعال": "غیر فعال"}</TableCell>


                <TableCell align="left" className={classes.actions}>
                    <Link to={`/discount-code/${row.id}`}>
                        <Tooltip title="ویرایش">
                            <IconButton>
                                <EditIcon/>
                            </IconButton>
                        </Tooltip>
                    </Link>
                    <div onClick={handleRemove}>
                        <Tooltip title="حذف">
                            <IconButton>
                                <DeleteIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </TableCell>
            </TableRow>
        );
    };
    const debounceSetSearchFor = useCallback(debounce(async function (value) {
        setParams((prev) => ({...prev, ['user_fullname']: value}))
    }, 1000), []);
    async function handleSearch(value, number = 0) {
        debounceSetSearchFor(value)
    }

    function addDiscountCode() {
        history.push('/discount-code');
    }

    return (
        <Grid item xs={11} sm={12} className="d-flex flex-column DivParentCreateProduct">
            <ContainerHeader
                data={{
                    filter: false,
                    addBtn: true,
                }}
                headerTitle="لیست کد تخفیف ها"
                titleBtn="افزودن"
                addBtnAction={addDiscountCode}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />
            {/*<Paper className="parentBoxSearchListProduct">*/}
            {/*    <Grid item xs={12} sm={6} md={5} lg={4}>*/}
            {/*        <TextField*/}
            {/*            label="عنوان جستجو"*/}
            {/*            variant="outlined"*/}
            {/*            size="small"*/}
            {/*            style={{width: '100%'}}*/}
            {/*            onChange={(e) => handleSearch(e.target.value)}*/}
            {/*        />*/}
            {/*    </Grid>*/}
            {/*</Paper>*/}
            <SortableTableMat
                link={'admin/coupons'}
                RowComponent={ExerciseRowTableModel}
                HeadCompnent={ExerciseHeadMedel}
                headers={headCells}
                // preParams={params}
                onRemove={removeNotice}
            />
        </Grid>
    );
}
